var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sellCollect padd30" },
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.activeName,
            callback: function($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName"
          }
        },
        [
          _c(
            "el-tab-pane",
            {
              staticClass: "pad10_t",
              attrs: { label: "按商品汇总", name: "good" }
            },
            [
              _c("div", { staticClass: "flex flex_wrap" }, [
                _c(
                  "div",
                  { staticClass: "pad20_r pad20_b" },
                  [
                    _c("span", { staticClass: "pad10_r" }, [_vm._v("时间")]),
                    _c("el-date-picker", {
                      attrs: {
                        "value-format": "yyyy-MM-dd",
                        type: "daterange",
                        "range-separator": "至",
                        "start-placeholder": "开始日期",
                        "end-placeholder": "结束日期",
                        clearable: false,
                        "picker-options": _vm.pickerOptions
                      },
                      model: {
                        value: _vm.time,
                        callback: function($$v) {
                          _vm.time = $$v
                        },
                        expression: "time"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "pad20_r pad20_b" },
                  [
                    _c("span", { staticClass: "pad10_r" }, [
                      _vm._v("订单状态")
                    ]),
                    _c(
                      "el-select",
                      {
                        staticClass: "w110",
                        attrs: { placeholder: "请选择" },
                        model: {
                          value: _vm.orderStatus,
                          callback: function($$v) {
                            _vm.orderStatus = $$v
                          },
                          expression: "orderStatus"
                        }
                      },
                      _vm._l(_vm.options, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "pad20_r pad20_b" },
                  [
                    _c("span", { staticClass: "pad10_r" }, [
                      _vm._v("商品分类")
                    ]),
                    _c(
                      "el-select",
                      {
                        attrs: {
                          filterable: "",
                          clearable: "",
                          placeholder: "请选择"
                        },
                        on: { change: _vm.classifyIdChange },
                        model: {
                          value: _vm.classifyId,
                          callback: function($$v) {
                            _vm.classifyId = $$v
                          },
                          expression: "classifyId"
                        }
                      },
                      _vm._l(_vm.goodsClassifies, function(item) {
                        return _c("el-option", {
                          key: item.classifyId,
                          attrs: {
                            label: item.classifyName,
                            value: item.classifyId
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "pad20_r pad20_b" },
                  [
                    _c("span", { staticClass: "pad10_r" }, [_vm._v("商品")]),
                    _c(
                      "el-select",
                      {
                        attrs: {
                          filterable: "",
                          clearable: "",
                          placeholder: "请选择"
                        },
                        model: {
                          value: _vm.goodsId,
                          callback: function($$v) {
                            _vm.goodsId = $$v
                          },
                          expression: "goodsId"
                        }
                      },
                      _vm._l(_vm.classifyGoodsMap, function(item) {
                        return _c("el-option", {
                          key: item.goodsId,
                          attrs: { label: item.name, value: item.goodsId }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "pad20_b" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.query(0)
                          }
                        }
                      },
                      [_vm._v("查询")]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "mar30_l",
                        attrs: { type: "primary" },
                        on: { click: _vm.exportSellCollectGoods }
                      },
                      [_vm._v("导出")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.resetGood }
                      },
                      [_vm._v("重置")]
                    )
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "box20" }),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.tableLoad,
                      expression: "tableLoad"
                    }
                  ],
                  staticClass: "min_width1000"
                },
                [
                  _c(
                    "el-table",
                    {
                      staticClass: "goodsOrderGroup",
                      staticStyle: { width: "100%", "min-width": "1000px" },
                      attrs: {
                        "row-style": _vm.rowStyle,
                        data: _vm.tableData,
                        "span-method": _vm.objectSpanMethodGoods,
                        border: ""
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: { label: "商品编号" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("span", { staticClass: "c_blue" }, [
                                  _vm._v(_vm._s(scope.row.goodsIdStr))
                                ])
                              ]
                            }
                          }
                        ])
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "goodsName", label: "货品名称" }
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "customerName", label: "客户" }
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "goodsQuantityAll", label: "销售数量" }
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "mSUnit", label: "销售单位" }
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "finalUnitConverAll", label: "结算数量" }
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "goodsSpec", label: "结算单位" }
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "sellFactPrice", label: "结算单价" }
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "totalAmount", label: "总价（元）" }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "el-tab-pane",
            {
              staticClass: "pad10_t",
              attrs: { label: "按客户汇总", name: "customer" }
            },
            [
              _c("div", { staticClass: "flex flex_wrap" }, [
                _c(
                  "div",
                  { staticClass: "pad20_r pad20_b" },
                  [
                    _c("span", { staticClass: "pad10_r" }, [_vm._v("客户")]),
                    _c(
                      "el-select",
                      {
                        attrs: {
                          filterable: "",
                          clearable: "",
                          placeholder: "请选择"
                        },
                        on: { change: _vm.customerIdChange },
                        model: {
                          value: _vm.customerId,
                          callback: function($$v) {
                            _vm.customerId = $$v
                          },
                          expression: "customerId"
                        }
                      },
                      _vm._l(_vm.customerEntityRes, function(item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: { label: item.name, value: item.userId }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "pad20_r pad20_b" },
                  [
                    _c("span", { staticClass: "pad10_r" }, [
                      _vm._v("客户分组")
                    ]),
                    _c(
                      "el-select",
                      {
                        attrs: {
                          filterable: "",
                          clearable: "",
                          placeholder: "请选择"
                        },
                        on: { change: _vm.customerIdChange },
                        model: {
                          value: _vm.customerGroupId,
                          callback: function($$v) {
                            _vm.customerGroupId = $$v
                          },
                          expression: "customerGroupId"
                        }
                      },
                      _vm._l(_vm.customerGroupList, function(item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: { label: item.name, value: item.id }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "pad20_r pad20_b" },
                  [
                    _c("span", { staticClass: "pad10_r" }, [
                      _vm._v("服务人员")
                    ]),
                    _c(
                      "el-select",
                      {
                        attrs: {
                          filterable: "",
                          clearable: "",
                          placeholder: "请选择"
                        },
                        on: { change: _vm.customerIdChange },
                        model: {
                          value: _vm.shopStaffId,
                          callback: function($$v) {
                            _vm.shopStaffId = $$v
                          },
                          expression: "shopStaffId"
                        }
                      },
                      _vm._l(_vm.shopStaffList, function(item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: { label: item.boName, value: item.boIdStr }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "pad20_r pad20_b" },
                  [
                    _c("span", { staticClass: "pad10_r" }, [_vm._v("商品")]),
                    _c(
                      "el-select",
                      {
                        attrs: {
                          filterable: "",
                          clearable: "",
                          placeholder: "请选择"
                        },
                        model: {
                          value: _vm.goodsId,
                          callback: function($$v) {
                            _vm.goodsId = $$v
                          },
                          expression: "goodsId"
                        }
                      },
                      _vm._l(_vm.shopGoodsList, function(item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: { label: item.name, value: item.goodsId }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "pad20_r pad20_b" },
                  [
                    _c("span", { staticClass: "pad10_r" }, [
                      _vm._v("订单状态")
                    ]),
                    _c(
                      "el-select",
                      {
                        staticClass: "w110",
                        attrs: { placeholder: "请选择" },
                        model: {
                          value: _vm.orderStatus,
                          callback: function($$v) {
                            _vm.orderStatus = $$v
                          },
                          expression: "orderStatus"
                        }
                      },
                      _vm._l(_vm.options, function(item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "pad20_r pad20_b" },
                  [
                    _c("span", { staticClass: "pad10_r" }, [_vm._v("时间")]),
                    _c("el-date-picker", {
                      attrs: {
                        "value-format": "yyyy-MM-dd",
                        type: "daterange",
                        "range-separator": "至",
                        "start-placeholder": "开始日期",
                        "end-placeholder": "结束日期",
                        clearable: false,
                        "picker-options": _vm.pickerOptions
                      },
                      model: {
                        value: _vm.time,
                        callback: function($$v) {
                          _vm.time = $$v
                        },
                        expression: "time"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "pad20_b" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.query(0)
                          }
                        }
                      },
                      [_vm._v("查询")]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "mar30_l",
                        attrs: { type: "primary" },
                        on: { click: _vm.exportSellCollectCustomer }
                      },
                      [_vm._v("导出")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.resetGood }
                      },
                      [_vm._v("重置")]
                    )
                  ],
                  1
                )
              ]),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.tableLoad,
                      expression: "tableLoad"
                    }
                  ],
                  staticClass: "min_width1000"
                },
                [
                  _c(
                    "el-table",
                    {
                      staticClass: "customerOrderGroup clientTable",
                      staticStyle: { width: "100%", "min-width": "1000px" },
                      attrs: {
                        data: _vm.customerOrderGroupList,
                        "row-style": _vm.rowStyle,
                        "span-method": _vm.objectSpanMethodCustomer,
                        border: ""
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: { label: "客户" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("span", { staticClass: "c_blue" }, [
                                  _vm._v(_vm._s(scope.row.customerName))
                                ])
                              ]
                            }
                          }
                        ])
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "serviceName", label: "服务人员" }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "orderGoodsBasisEntity.goodsName",
                          label: "货品名称"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "orderGoodsBasisEntity.goodsQuantityAll",
                          label: "销售数量"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "orderGoodsBasisEntity.mSUnit",
                          label: "销售单位"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "orderGoodsBasisEntity.finalUnitConverAll",
                          label: "结算数量"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "orderGoodsBasisEntity.goodsSpec",
                          label: "结算单位"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "orderGoodsBasisEntity.sellFactPrice",
                          label: "结算单价"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "orderGoodsBasisEntity.totalAmount",
                          label: "总价（元）"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }